import baseApi from "./baseApi"

export default  {
    /**
     * Get Plant Locations     
     */
    async getLookups(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/crops/lookups?plantID=' + plantID);
        return result.data;
    },
    async isValid(crop) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post('/crops/valid', crop);
        return result.data;
    },
    async getCrop(cropID, clone) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/crops?id=' + cropID + '&clone=' + clone);
        return result.data;
    },
    async getCropByCropLocationID(cropID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/crops/GetCropByCropLocationID?id=' + cropID);
        return result.data;
    },
    async save(crop) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post('/crops', crop);
        return result.data;
    },
    async batchGetCropEndDateEditData(cropIDs) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/crops/BatchGetCropEndDateEditData?cropids=' + cropIDs);
        return result.data;
    },
    async batchSaveCropEndDateEditData(cropEndDateEditData) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post('/crops/BatchSaveCropEndDateEditData', cropEndDateEditData);
        return result.data;
    }
}